import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import {
  fund_recieved_dwo,
  getAllBlocksFromDistrict,
  getAmenitiesType,
  school_name_block_wise,
} from "../api/Users";
import TopLoader from "../components/Loader/TopLoader";
import { Typography, TablePagination } from "@mui/material";
import { toast } from "react-toastify";

function LimitAllocationDWO({ role, userData }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [limitAllocationData, setLimitAllocationData] = useState([]);
  const [allBlock, setAllBlock] = useState([]);
  const [allSchoolNames, setAllSchoolNames] = useState([]);
  const [allAmenityTypes, setAllAmenityTypes] = useState([]);
  const [filterData, setFilterData] = useState({
    block: 0,
    school: 0,
    amenity: 0,
  });

  const [fundType, setFundType] = useState("all");

  const handleFundType = async (e) => {
    setFundType(e.target.value);
  };
  const getLimitAllicationData = (fundtype) => {
    setIsLoading(true);
    const data = {
      fund_master_id: fundtype,
      district_code: userData.data.district_code,
    };

    fund_recieved_dwo(data)
      .then((response) => {
        if (response.status == "success") {
          setIsLoading(false);
          setLimitAllocationData(response.data.result);
        } else {
          setIsLoading(false);
          setLimitAllocationData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  const onloadApis = () => {
    setIsLoading(true);

    getAmenitiesType()
      .then((response) => {
        if (response.status == "success") {
          setIsLoading(false);
          setAllAmenityTypes(response.data.assets_name);
        } else {
          setIsLoading(false);
          setAllAmenityTypes([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  useEffect(() => {
    getLimitAllicationData("all");
    onloadApis();
  }, []);

  const handleAmenityChange = (value) => {
    setFilterData({
      amenity: value,
    });
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <h5 className="my-3 mb-3">{t("Limit Allocation")}</h5>
        <form action="" id="myform" style={{ marginTop: "3rem" }}>
          <div className="AmenityFilter row" style={{ marginTop: "12px" }}>
            <div className="col-md-3">
              <label className="form-label">
                {t("Fund Type")} <span style={{ color: "red" }}>*</span>
              </label>
              <select
                name="asset_type_id"
                className="common-input form-select"
                onChange={handleFundType}
                value={fundType}
                required
              >
                {/* <option value="">{t("Select Fund Type")}</option> */}
                <option value="all">{t("All")}</option>
                <option value="1">{t("Generic")}</option>
                <option value="2">{t("Additional")}</option>
              </select>
            </div>
            <div className="col-md-3">
              <button
                type="button"
                className="btn btn-primary btn-sm  mx-2"
                style={{ marginTop: "35px" }}
                onClick={() => getLimitAllicationData(fundType)}
              >
                {t("Search")}
              </button>
            </div>
          </div>
        </form>

        <TableContainer
          component={Paper}
          style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
          className="my-4"
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className="border border-0">
                  {t("Sr. No.")}
                </TableCell>
                <TableCell align="center" className="border border-0">
                  {t("Fund Type")}
                </TableCell>
                <TableCell align="center" className="border border-0">
                  {t("Fund Sub Type")}
                </TableCell>
                <TableCell align="center" className="border border-0">
                  {t("Fund Received")}
                </TableCell>
              </TableRow>
            </TableHead>
            {!isLoading &&
              limitAllocationData &&
              limitAllocationData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {limitAllocationData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          {getSerialNumber(index)}
                        </TableCell>
                        <TableCell align="center">{row.head_name}</TableCell>
                        <TableCell align="center">
                          {row.sub_type_name}
                        </TableCell>
                        <TableCell align="center">{row.total_limit}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
            {!isLoading &&
              (!limitAllocationData || limitAllocationData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={limitAllocationData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
}

export default LimitAllocationDWO;
